"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.imgGen.name': 'Generación de Imágenes',
    'tools.imgGen.description': 'Genera imágenes a partir de descripciones de texto',
};
